module.exports = __webpack_public_path__ + "static/media/logo-speedy.fe4008ba.png";